import MailIcon from '@mui/icons-material/MailOutline';
import FailedEmailsList from './FailedEmailsList';

export default {
    list: FailedEmailsList,
    icon: MailIcon,
};
